import QdtComponents from 'qdt-components'

export default ({ app }, inject) => {
  const prodId = '2d802ad8-3baf-4200-b89b-0f753f6d6abe'
  const testId = '8c31d2bd-66c2-4910-bc46-aa52267f63e4'
  const devId = '53ba81c1-8f66-4be4-9fda-3310d721264e'
  //const host = 'devdashboards.philasd.org'//app.$host
  //'devdashboards.philasd.org'
  
  const host = window.location.hostname === 'localhost' ? 'devdashboards.philasd.org' : app.$host
  
  const appId = (() => {
    if (host.indexOf("dev") !== -1)  {
      return devId;
    }
    else if (host.indexOf("test") !== -1) {
      return testId;
    }
    else {
      return prodId;
    }
  })();
  
  const config = {
    host,
    prefix: '',
    port: 443, // window.location.port,
    secure: true,
    appId,
  }
  const connections = {
    vizApi: true,
    engineApi: true,
  }
  const qdtComponents = new QdtComponents(config, connections)

  inject('qdt', qdtComponents)
}
